import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import {
  getTransferOrders,
  createTransferOrderApi,
  getTransferOrder,
  updateTransferOrderApi,
  updateStatusTransferOrderApi,
  deleteTransferOrderApi,
} from "../../helpers/";
import { TransferOrdersActionTypes } from "./constants";
import {
  transferOrdersGetListSuccess,
  transferOrdersGetListError,
  createTransferOrderSuccess,
  createTransferOrderError,
  getTransferOrderSuccess,
  getTransferOrderError,
  updateTransferOrderSuccess,
  updateTransferOrderError,
  updateStatusTransferOrderSuccess,
  updateStatusTransferOrderError,
  deleteTransferOrderSuccess,
  deleteTransferOrderError,
} from "./actions";

function* fetchList({ payload }: any): SagaIterator {
  try {
    const response = yield call(getTransferOrders, payload);
    yield put(transferOrdersGetListSuccess(response.data));
  } catch (e: any) {
    yield put(transferOrdersGetListError(e?.response?.data?.error || "Error"));
  }
}

function* createOne({ payload }: any): SagaIterator {
  try {
    const response = yield call(createTransferOrderApi, payload);
    yield put(createTransferOrderSuccess(response.data));
  } catch (e: any) {
    yield put(createTransferOrderError(e?.response?.data?.error || "Error"));
  }
}

function* fetchOne({ payload }: any): SagaIterator {
  try {
    const response = yield call(getTransferOrder, payload.id);
    yield put(getTransferOrderSuccess(response.data));
  } catch (e: any) {
    yield put(getTransferOrderError(e?.response?.data?.error || "Error"));
  }
}

function* updateOne({ payload }: any): SagaIterator {
  try {
    const response = yield call(updateTransferOrderApi, payload.id, payload.data);
    yield put(updateTransferOrderSuccess(response.data));
  } catch (e: any) {
    yield put(updateTransferOrderError(e?.response?.data?.error || "Error"));
  }
}

function* updateStatus({ payload }: any): SagaIterator {
  try {
    const response = yield call(updateStatusTransferOrderApi, payload.id, payload.data);
    yield put(updateStatusTransferOrderSuccess(response.data));
  } catch (e: any) {
    yield put(updateStatusTransferOrderError(e?.response?.data?.error || "Error"));
  }
}

function* deleteOne({ payload }: any): SagaIterator {
  try {
    yield call(deleteTransferOrderApi, payload.id);
    yield put(deleteTransferOrderSuccess());
  } catch (e: any) {
    yield put(deleteTransferOrderError(e?.response?.data?.error || "Error"));
  }
}

export function* watchTransferOrders() {
  yield takeEvery(TransferOrdersActionTypes.GET_LIST,      fetchList);
  yield takeEvery(TransferOrdersActionTypes.CREATE,        createOne);
  yield takeEvery(TransferOrdersActionTypes.GET_ONE,       fetchOne);
  yield takeEvery(TransferOrdersActionTypes.UPDATE,        updateOne);
  yield takeEvery(TransferOrdersActionTypes.UPDATE_STATUS, updateStatus);
  yield takeEvery(TransferOrdersActionTypes.DELETE,        deleteOne);
}

function* transferOrdersSaga() {
  yield all([fork(watchTransferOrders)]);
}

export default transferOrdersSaga;
